const downloadPdfFile = async (file: Blob, fileName: string): Promise<void> => {
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(file);
  link.download = fileName;
  link.click();
};
export default downloadPdfFile;
